// extracted by mini-css-extract-plugin
export var hidden = "_vs-0";